import React from 'react';

import Pill from 'common/common/Pill';
import styles from 'css-module/components/subdomain/admin/settings/AdminIntegrationSettings/_AdminIntegrationCard.module.scss';

type Props = {
  credits?: number | { min: number; max: number };
};

const AdminIntegrationCardCreditPill = ({ credits }: Props) => {
  if (!credits) {
    return null;
  }

  const getCreditText = (credits: number | { min: number; max: number }) => {
    if (typeof credits === 'number') {
      return `${credits} ${credits > 1 ? 'credits' : 'credit'}`;
    }

    return `${credits.min}-${credits.max} credits`;
  };

  return <Pill className={styles.costPill}>{getCreditText(credits)}</Pill>;
};

export default AdminIntegrationCardCreditPill;
